import { ListCategory } from '../client/types';

export const findCategoryByName = (categories: ListCategory[], name: string): ListCategory | undefined => {
    const lower = name.toLowerCase().trim();
    const categoriesLowerCased = categories.map(c => ({ category: c, lowerC: c.name.toLowerCase() }));
    const match =
        categoriesLowerCased.find(({ lowerC }) => lowerC === lower) ??
        categoriesLowerCased.find(({ lowerC }) => lowerC.includes(lower) || lower.includes(lowerC));
    return match?.category;
};
